/**
 * Redux store configuration with RTK Query.
 *
 * Feature modules inject endpoints into `apiSlice` from their own files
 * (`src/features/<name>/…`) — this shell file only wires the slices themselves.
 * The `auth` slice arrived with the auth feature (P1-T4).
 */

import { configureStore } from '@reduxjs/toolkit';

import authReducer from '@/features/auth/authSlice';

import { apiSlice } from './apiSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    [apiSlice.reducerPath]: apiSlice.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(apiSlice.middleware),
  devTools: import.meta.env.DEV,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
